import React, { useState, useEffect, useCallback, useRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { TabBarNav } from "../TabBarNav/TabBarNav";
import "./TabBar.scss";

const scrollToRef = (ref) => ref.current.scrollTop = 0;

export const TabBarWrapper = ({ children, className, navProps = {}, onClickTab }) => {
    const [ activeTab, setActiveTab ] = useState(null);
    const myRef = useRef(null);
    const classes = classNames(
        "tab-bar",
        className
    );

    const getChildrenLabel = (children) => children.map((rootProps) => rootProps?.props?.label);

    const setActiveTabLabel =  useCallback(
        (active, index = 0) => {
            if(activeTab !== active){
                setActiveTab(active);

                if(typeof onClickTab === "function") {
                    onClickTab(active, index);
                }
            }
        },
        [ activeTab, onClickTab ]
    );

    const renderTabs = () => getChildrenLabel(children).map((navLabel, index) => {
        const currentNavProps = navProps[navLabel];

        return (
            navLabel ? (
                <TabBarNav
                    key={navLabel}
                    navLabel={navLabel}
                    className={classNames({ active: activeTab === navLabel }, currentNavProps?.className)}
                    onChangeActiveTab={() => setActiveTabLabel(navLabel, index)}
                />
            ) : null
        );
    });

    useEffect(() => {
        if(!activeTab){
            const activeTab = getChildrenLabel(children)[0];
            setActiveTabLabel(activeTab);
        }
    },[ children, setActiveTabLabel, activeTab ]);

    useEffect(() => {
        scrollToRef(myRef);
    }, [ activeTab ]);

    return (
        <div className={classes}>
            <div className="tab-bar-nav">
                {renderTabs()}
            </div>

            <div
                ref={myRef}
                className={"tab-container"}
            >
                {React.Children.map(children, child => child && React.cloneElement(child, { activeTab }))}
            </div>
        </div>
    );
};

TabBarWrapper.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
};

TabBarWrapper.defaultProps = {
    children: null,
    className: ""
};
